import axios from "axios";
import env from "../../../../env/src_config";

export const fillSearch = (id, headers) => {
    // This endpoint is "public" for now, it needs to go to "private"
    axios.post(env.api.public + 'publication/fillsearch ', { id }, headers).then(() => {}, (error) => {console.log(error)});
}